<template lang="pug">
    #invoice-customer-preview.d-flex.justify-center.pa-md-10.pa-5
        v-row
            v-col(cols="12")
                .pdf-container
                    v-row.d-none.d-md-block
                        v-col(cols="12")
                            v-btn.no-print.mr-6(rounded outlined @click="print") {{$t('ActionOption.__Print')}}
                            v-btn.no-print.mr-6(rounded outlined @click="downloadPDF") {{$t('ActionOption.__ExportPDF')}}
                    v-row.mb-10
                        v-col(cols="12")
                            .pdf-view
                                InvoiceViewPage(:invoice-id="id" :is-shared="isShared" @invoice-updated="updateInvoice" :data="data")

                    v-row.no-print.text-center
                        v-col(cols="12")
                            v-btn(rounded outlined color="primary") {{$t('EstimatesAndInvoices.__PoweredBy')}}
                        v-col.footer(col="12")
                            span.mr-2 © 2021 2SUMUP Company 
                            a.mr-2(href="https://www.2sumup.com/blank-1" target="_blank") {{$t('Auth.__TermsOfService')}}
                            a(href="https://www.2sumup.com/blank-2" target="_blank") {{$t('Auth.__PrivacyPolicy')}}



</template>
<script>
import InvoiceViewPage from "@/components/InvoiceViewPage"
import * as PDF from "@/utils/pdf"

export default {
  components: {
    InvoiceViewPage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      id: "",
      isShared: false,
      invoice: {}
    }
  },
  methods: {
    print() {
      // window.print()
      this.$router.push({
        name: "InvoiceExport",
        params: {
          invoiceId: this.id,
          data: this.data,
          exportType: "print",
          isShared: this.isShared
        }
      })
    },
    downloadPDF() {
      PDF.download("#invoice-preview-page", this.invoice.name + "_" + this.invoice.number, () => {})
    },
    updateInvoice(invoice) {
      this.invoice = invoice
    }
  },
  created() {
    if (this.data == null) {
      this.id = this.$route.params.id
      if (this.id == null) {
        this.$router.push({
          name: "Bills"
        })
      }
      if (this.$route.name == "SharedInvoiceView") {
        this.isShared = true
      }
    } else {
      this.invoice = this.data
    }
  }
}
</script>

<style lang="scss">
.footer {
  font-size: 13px;
}

.pdf-view {
  max-width: 1024px;
  min-height: 1248px;
}

#invoice-customer-preview {
  .preview-content {
    max-width: 960px;
  }

  background-color: #f8f8f8;
}

@media print {
  #invoice-customer-preview {
    background-color: white;
    padding: 0px;
    .preview-card {
      margin: 0 !important;
      box-shadow: none !important;
    }
  }
  .no-print {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
